


























































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import SessionModule from '~/store/session';
import styles from '~/assets/style/variables.scss';
import EnrollmentModule from '~/store/enrollment';
import { ProgramState } from '~/types/types';
import Path from '~/store/path';

@Component<Header>({})
export default class Header extends Vue {
  @Resolve
  session!: SessionModule;
  @Resolve
  enrollment!: EnrollmentModule;
  @Resolve
  public path! :Path

  styles = styles;

  getLocalPath(){
    return localStorage.getItem('madrigal-path') === 'portal-login';
  }

  getLogoIcon() {
    const state = this.enrollment.programState;
    const programItem = this.$settings.landingMenu.find((item) => item.programState === state);
    return (programItem || ({} as any)).image;
  }

  handleLogoClick() {
    this.enrollment.clearStore();
    this.enrollment.setProgramState(ProgramState.Gilead);
    if (this.session.isAuthenticatedUser) {
      this.$router.push({ path: '/landing' });
    } else if (!this.isLoginPage()) {
      this.$router.push({ path: '/' });
    }
  }

  isLoginPage() {
    return this.$router.currentRoute.path === '/';
  }

  async headerLogo(){
    this.path.clearPath();
    this.enrollment.clearStore();
    await this.session.logout({ returnTo: this.$settings.absoluteUrlFromRoute({ name: 'index' }).replace('/madrigal/rezdiffra', '') });
    this.$router.push({ name: 'landing' });
  }
}
